import { Box, Grid, TextField, Typography, useTheme } from "@mui/material";
import { useContext, useMemo, useState } from "react";
import { AppContext } from "../../contextProviders/AppContext";
import { translation } from "../Dictionary";

export default function DatePickerDateInput({
  pickerProps,
  id,
  contentHeigth,
}) {
  const { FEATURE_FIXED_RESERVATION_DURATION, language } =
    useContext(AppContext);
  const singleDayPicker = id === "single-day-picker" ? true : false;
  const theme = useTheme();
  const pickerFocused = useMemo(() => {
    const result = pickerProps.focused;
    return result;
  }, [pickerProps.focused]);

  // modify props to access readOnly and set it true.
  // this prevents crashing when typing something in to the textfield, because the value needs to be a date
  const customProps = {
    ...pickerProps,
    inputProps: {
      ...pickerProps.inputProps,
      readOnly: true,
      placeholder: "päivämäärä",
      style: { cursor: "pointer" },
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: contentHeigth,
        flexDirection: "column",
        flex: 1,
        justifyContent: "flex-start",
        alignItems: "flex-start",
        backgroundColor: "white",
        borderRadius: "10px",
        boxShadow: pickerFocused ? theme.shadows[2] : "transparent",
        border: customProps.error ? "1px red solid" : undefined,
        justifyContent: "center",
        alignItems: "center",
        transition: "ease-in-out 250ms",
        bgcolor: pickerFocused ? "white" : "transparent",
        cursor: "pointer",
        "&:hover": {
          bgcolor: "rgba(0,0,0,0.05)",
          boxShadow: theme.shadows[2],
        },
      }}
      onClick={(e) =>
        customProps.disabled
          ? null
          : customProps.onClick
          ? customProps.onClick(e)
          : null
      }
    >
      <Typography color={theme.palette.primary.mainText}>
        {FEATURE_FIXED_RESERVATION_DURATION ? (
          <>{translation.get(language, "Start reservation text")}</>
        ) : (
          customProps.label
        )}
      </Typography>
      <Typography color={theme.palette.primary.mainText}>
        {customProps.inputProps.value}
      </Typography>
    </Box>
  );
}
